module.exports = __webpack_public_path__ + "static/avatar_qbt-1e3e79e019013e14d9c0bb1bb26ab7c3.png";